import {Skeleton, Box} from "@mui/material";
import React from "react";


const GoogleOrApplePaySkeleton = () => {
  return (
    <Box>
      <Skeleton variant="rectangular" sx={{ borderRadius: 1, padding: '12px', height: '42px' }} />
    </Box>
  )
};
export default GoogleOrApplePaySkeleton;